export const infantFields = [
  'id',
  'date-of-birth',
  'first-name',
  'gender',
  'last-name',
]

export default (passengerId: string, formValues: any) => {
  const infantValues = infantFields.reduce(
    (allFieldValues: any, field: string) => ({
      ...allFieldValues,
      [field]: formValues[`${passengerId}-infant-${field}`],
    }),
    {}
  )

  const hasValues = Object.values(infantValues).filter((value: any) => value)
    .length

  return hasValues ? infantValues : undefined
}
